import { ApolloError } from "@apollo/client";
import { Fragment, ReactNode } from "react";
import { appStrings } from "utils/appStrings";
import Loading from "./Loading";

export interface PageLoaderProps {
  loading: boolean;
  error?: ApolloError | string;
  children: ReactNode;
  showError?: boolean;
  onRefresh: () => void;
}

const PageLoader: React.FC<PageLoaderProps> = ({
  loading,
  error,
  children,
  showError = true,
  onRefresh,
}) => {
  if (loading) {
    return (
      <div className="py-24 mx-auto">
        <Loading />
      </div>
    );
  }

  if (error && showError) {
    return (
      <div className="flex w-full item-center justify-center">
        <div>
          <p className="bg-pink-100 text-pink-800 font-bold rounded-3xl py-4 px-8 flex flex-row items-center mb-8 dark:bg-pink-800 dark:text-pink-100">
            {typeof error === "string" ? error : appStrings.defaultError}
          </p>
          <button
            className="block mx-auto bg-gray-200 text-primary-600 font-semibold py-2 px-6 rounded-xl dark:bg-gray-800"
            onClick={() => onRefresh()}
          >
            {appStrings.tryAgain}
          </button>
        </div>
      </div>
    );
  }

  return <Fragment>{children}</Fragment>;
};

export default PageLoader;
